/**
 * Phone number formatting utility
 * Formats US phone numbers as (XXX) XXX-XXXX
 * Used across all phone input fields for consistency
 */

/**
 * Format a phone number string as (XXX) XXX-XXXX
 * Strips all non-digits, then applies formatting as user types
 * @param {string} value - Raw input value
 * @returns {string} Formatted phone number
 */
export function formatPhoneNumber(value) {
  if (!value) return '';
  
  // Strip everything except digits
  const digits = value.replace(/\D/g, '');
  
  // Remove leading 1 (country code) if 11 digits
  const cleaned = digits.length === 11 && digits.startsWith('1') ? digits.slice(1) : digits;
  
  // Apply formatting based on length
  if (cleaned.length === 0) return '';
  if (cleaned.length <= 3) return `(${cleaned}`;
  if (cleaned.length <= 6) return `(${cleaned.slice(0, 3)}) ${cleaned.slice(3)}`;
  return `(${cleaned.slice(0, 3)}) ${cleaned.slice(3, 6)}-${cleaned.slice(6, 10)}`;
}

/**
 * Strip formatting to get raw digits (for storage/API calls)
 * @param {string} formatted - Formatted phone string
 * @returns {string} Raw digits only
 */
export function stripPhoneFormatting(value) {
  if (!value) return '';
  return value.replace(/\D/g, '').slice(0, 10);
}

/**
 * Validate a phone number (must be 10 digits after stripping)
 * @param {string} value - Phone number (formatted or raw)
 * @returns {boolean}
 */
export function isValidPhone(value) {
  if (!value) return false;
  const digits = value.replace(/\D/g, '');
  return digits.length === 10;
}
